import { useContext } from 'react';

import ShareContext from './share.context';

function useShare() {
  const context = useContext(ShareContext);

  if (!context) {
    throw new Error('useShare must be used within ShareContext');
  }

  return context;
}

export default useShare;